import React, {Component} from 'react';
import DeckGL, {ScatterplotLayer, HexagonLayer} from 'deck.gl';
import {interpolateRgb} from 'd3-interpolate';

// Constants for hexagon layer
const HEATMAP_COLORS = [
  [213, 62, 79],
  [252, 141, 89],
  [254, 224, 139],
  [230, 245, 152],
  [153, 213, 148],
  [50, 136, 189]
].reverse();

const LIGHT_SETTINGS = {
  lightsPosition: [-73.8, 40.5, 8000, -74.2, 40.9, 8000],
  ambientRatio: 0.4,
  diffuseRatio: 0.6,
  specularRatio: 0.2,
  lightsStrength: [0.8, 0.0, 0.8, 0.0],
  numberOfLights: 2
};

const elevationRange = [0, 5000];

export default class DeckOverlay extends Component {

  _initialize(gl) {
    gl.enable(gl.DEPTH_TEST);
    gl.depthFunc(gl.LEQUAL);
  }

  _interpolate(d) {
    // when using SA values to assign color as a gradient
    const interpolateColor = interpolateRgb(this.props.colors.ep, this.props.colors.sa);
    const color = interpolateColor(d.sa);
    const rgb = color.match(/\d+/g).map(Number);
    return rgb;
  }

  render() {
    if (!this.props.data) {
      return null;
    }

    const filteredData = this.props.highlightedLion === null
      ? this.props.data
      : this.props.data.filter(d => d.lion === this.props.highlightedLion);

    const layers = [
      !this.props.showHexagon ? new ScatterplotLayer({

        id: 'scatterplot',
        getPosition: d => d.position,
        getColor: d => this._interpolate(d),
        getRadius: d => 5,
        opacity: 0.5,
        pickable: true,
        radiusMinPixels: 0.25,
        radiusMaxPixels: 30,
        ...this.props,
        data: filteredData
      }) : null,
      this.props.showHexagon ? new HexagonLayer({
        id: 'heatmap',
        colorRange: HEATMAP_COLORS,
        elevationRange,
        elevationScale: 5,
        extruded: true,
        getPosition: d => d.position,
        lightSettings: LIGHT_SETTINGS,
        opacity: 1,
        pickable: true,
        radius: 400,
        ...this.props,
        data: filteredData
      }) : null
    ];


    return (
      <DeckGL
        {...this.props.viewport}
        layers={layers}
        onWebGLInitialized={this._initialize}/>
    );
  }

}



// WEBPACK FOOTER //
// ./src/deckgl-overlay.js